import * as React from "react";

function SvgRight(props) {
  return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" {...props}><path d="M15.1 3h2v14h-2zM2.9 10.6V9.4h8.6l-1.3-1.3L11 7l3 3-3 3-.8-1.1 1.3-1.3H2.9z" /></svg>;
}

export default SvgRight;